import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApplicantService } from './application-management.service';
import { ApplicantGridConfiguration, ApplicantRequestModel } from './application-management.model';
import { DxDataGridComponent } from 'devextreme-angular';
import { DxGridHelper } from '../../shared/helpers/dx-grid-helper';


@Component({
  selector: 'app-application-management-table',
  templateUrl: './application-management-table.component.html',
  styleUrls: ['./application-management-table.component.less'],
})
export class ApplicationManagementTableComponent implements OnInit, AfterViewInit {
  @Input() applicants;
  @Input() activeTab: string;
  @Output() showApplicantChange = new EventEmitter();

  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  showUser = false;
  deleteApplicantFlag = false;
  applicantId: number;
  searchValue: string;

  applicantGridConfiguration: ApplicantGridConfiguration;
  applicantGridRequest: ApplicantRequestModel;

  constructor(private _applicantService: ApplicantService) {
  }

  ngOnInit() {
    this.applicantGridConfiguration = new ApplicantGridConfiguration();
    this.applicantGridConfiguration.service = this._applicantService;
    this.applicantGridRequest = new ApplicantRequestModel();
    // Re-Review is a derived state, not a MemberStatus, so it travels as its own flag. The API
    // ignores status when reReview is true, but it still has to be a name the enum can bind:
    // the endpoint has no [ValidateModel] and dereferences request.Status, so an unbindable value
    // arrives as a null model and returns 500 rather than a validation error.
    this.applicantGridRequest.reReview = this.activeTab === 'reReview';
    this.applicantGridRequest.status = this.applicantGridRequest.reReview ? 'Waitlisted' : this.activeTab;
  }

  ngAfterViewInit(): void {
    DxGridHelper.ConfigureGrid(this.grid, this.applicantGridRequest, this.applicantGridConfiguration);
  }

  show(id: number) {
    this.showUser = true;
    this.applicantId = id;
  }

  updateList() {
    this.applicantGridConfiguration.refreshGrid();
    this.showApplicantChange.emit();
  }

  deleteApplicantInfo(e, id) {
    e.stopPropagation();
    this.applicantId = id;
    this.deleteApplicantFlag = true;
  }

  cancel() {
    this.deleteApplicantFlag = false;
  }

  deleteApplicant() {
    this._applicantService.deleteApplicant(this.applicantId)
      .subscribe(
        (response) => {
          console.log(response);
          this.cancel();
          this.updateList();
        },
        (error) => {
          console.log(error);
          this.cancel();
        });
  }

  search(value) {
    this.applicantGridConfiguration.customSearch[0].value = value;
    this.applicantGridConfiguration.customSearch[1].value = value;
    this.applicantGridConfiguration.dataGrid.instance.getDataSource().reload();
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/application-management-table.component.ts